"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const unhandledRejectionHandler = (event) => {
    var _a;
    (_a = event.promise) === null || _a === void 0 ? void 0 : _a.catch((error) => {
        // This code will throw an error in the window scope and we can not assert for it in a unit test.
        // istanbul ignore next
        if (error instanceof Error && error.message !== undefined && error.message !== '') {
            return;
        }
        event.preventDefault();
    });
};
exports.default = unhandledRejectionHandler;
//# sourceMappingURL=UnhandledRejectionHandler.js.map